export default "__VITE_ASSET__kjb5TWxy__"